import React, { useContext, useEffect, useState } from "react";
import Layout from "../Layout";
import { AuthContext } from "../../authContext";
import UniversityLoader from "../../Components/UniversityLoader";
import language from "../../localization";

const INITIAL_LOADER_EXIT_MS = 320;

const AppWrapper = () => {
  const authContext = useContext(AuthContext);
  const [showInitialLoader, setShowInitialLoader] = useState(authContext.loading);
  const [isLoaderExiting, setIsLoaderExiting] = useState(false);

  useEffect(() => {
    if (authContext.loading) {
      setShowInitialLoader(true);
      setIsLoaderExiting(false);
      return undefined;
    }

    if (!showInitialLoader) return undefined;

    // Keep the overlay mounted only long enough for the real exit transition.
    setIsLoaderExiting(true);
    const timer = window.setTimeout(() => setShowInitialLoader(false), INITIAL_LOADER_EXIT_MS);
    return () => window.clearTimeout(timer);
  }, [authContext.loading, showInitialLoader]);

  const shouldRenderLayout = !authContext.loading || isLoaderExiting;

  return (
    <>
      {shouldRenderLayout ? <Layout /> : null}
      {showInitialLoader ? <UniversityLoader exiting={isLoaderExiting} message={language.loading_website} /> : null}
    </>
  );
}

export default AppWrapper;